<template>
  <div>
      <v-card>
        <v-card-title>
            <v-toolbar color="primary" dark>
                <v-toolbar-title aling="center">Importacion masiva de evaluaciones historicas</v-toolbar-title>
            </v-toolbar>
        </v-card-title>
        <v-card-subtitle class="d-flex justify-center">
          
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  accept=".xlsx"
                  label="Ingrese la tabla en excel segun el formato"
                  outlined
                  v-model="chosenFile"
                >
                </v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
            <v-btn dark color="blue" :href="api+'public/EjemploHistoryEval.xlsx'">Ver Ejemplo</v-btn>
          <v-spacer></v-spacer>
            <v-btn dark color="success" @click="enviar" v-if="datos.length > 0">Guardar</v-btn>
        </v-card-actions>
      </v-card>

      <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="datos"
            :items-per-page="5"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>

  </div>
</template>
<script>
import axios from "axios";
import api from "../conf/ruta-base";
import router from '../router';
import store from "../store";
import readXlsxFile from 'read-excel-file'
import moment from "moment";
moment.locale('es');
import swal from 'sweetalert';
export default {
  name: 'excel',
  data() {
    return {
      chosenFile: null, search: '',
      headers: [
        { text: "Codigo", value: "codigo"},
        { text: "Etapa", value: "etapa"},
        { text: "Evaluacion", value: "evaluacion"},
        { text: "Competencias", value: "vcom"},
        { text: "Objetivos", value: "vobj"},
        { text: "Nro Competencias", value: "nroobj"},
        { text: "Nro Objetivos", value: "nrocom"},
      ],
      datos:[],
      api: null,
    }
  },
  mounted() {
      this.api = api.api
  },
  methods: {
    decodeXlsx(){
      readXlsxFile(this.chosenFile).then((rows) => {
        if(rows[0][0]!='codigo'){
          swal('','Lo siento no he podido validar el documento, favor verificalo','error')
          return null
        }
        for(let i = 1; i < rows.length; i++){
          let datos = {
            codigo: rows[i][0],
            nombres: rows[i][1],
            apellidos: rows[i][2],
            correo: rows[i][3],
            cargo: rows[i][4],
            cod_dpto: rows[i][5],
            depto: rows[i][6],
            supervisor: rows[i][7],
            grupo: rows[i][8],
            calificacion_med_sup: rows[i][9],
            calificacion_fin_sup: rows[i][10],
            etapa: rows[i][11],
            evaluacion: rows[i][12],
            vcom: rows[i][13],
            vobj: rows[i][14],
            prom_obj_med_col: rows[i][15],
            prom_obj_med_sup: rows[i][16],
            prom_obj_fin_col: rows[i][17],
            prom_obj_fin_sup: rows[i][18],
            prom_com_med_col: rows[i][19],
            prom_com_med_sup: rows[i][20],
            prom_com_fin_col: rows[i][21],
            prom_com_fin_sup: rows[i][22],
            pon_med: rows[i][23],
            pon_fin: rows[i][24],
            nroobj: rows[i][25],
            nrocom: rows[i][26],
          }
        this.datos.push(datos)
        }
      })
    },
    enviar(){
      axios
        .post(api.api + 'reporte/masivo', this.datos)
        .then(res => {
          this.toast(res.data.c, res.data.mensaje);
          router.push('/reportes')
        })
        .catch(error => {
            console.log(error);
        });
    },
    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    }
  }, 
  watch: {
    chosenFile(val){
      if(val != undefined){
        this.decodeXlsx()
      }else{
        this.datos = []
      }
    }
  },
}
</script>